"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeafletMap = exports.initLeafletMaps = void 0;
var Leaflet_1 = require("../lib/Leaflet");
require("leaflet-responsive-popup");
require("leaflet.markercluster");
// @ts-ignore
var leaflet_vector_tile_layer_1 = require("leaflet-vector-tile-layer");
function initLeafletMaps() {
    addLeafletMapStyle();
    var leafletMaps = document.querySelectorAll(".js-leaflet-map");
    leafletMaps.forEach(function (mapElement) {
        new LeafletMap(mapElement);
    });
}
exports.initLeafletMaps = initLeafletMaps;
var RAILWAY_TRACK_COLOUR = "#7C7C7C";
var LeafletMap = /** @class */ (function (_super) {
    __extends(LeafletMap, _super);
    function LeafletMap(mapElement) {
        var _this = _super.call(this, mapElement) || this;
        _this.url = 'https://maps.oebb.at/osm-liberty-oebb-austria';
        _this.leafletMapId = mapElement.dataset.leafletMapId;
        _this.imageServiceBaseUrl = mapElement.dataset.imageServiceBaseUrl || "";
        _this.maxZoom = 11;
        _this.url = mapElement.dataset.mapsUrl || _this.url;
        _this.initDom(true);
        _this.initListeners();
        _this.initScrollBehavior();
        _this.initTracksLayer();
        _this.initPoiMarkers();
        return _this;
    }
    LeafletMap.prototype.initTracksLayer = function () {
        var tileLayer = (0, leaflet_vector_tile_layer_1.default)('https://tiles.arcgis.com/tiles/jHdCsOKkBSDKvuhr/arcgis/rest/services/streckenuebersicht/VectorTileServer/tile/{z}/{y}/{x}.pbf');
        tileLayer.setStyle({
            weight: 2,
            color: RAILWAY_TRACK_COLOUR,
        });
        tileLayer.addTo(this.map);
    };
    LeafletMap.prototype.initPoiMarkers = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var enabledCategories_1, pois, overlayMaps, markersByCategory, _i, pois_1, poi, _b, _c, category, categoryId, markers_1, categoryLayerGroup, markers, iconUrl, borderColour, icon, marker, overlayText, overlay, layerControl, e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        enabledCategories_1 = [];
                        document.querySelectorAll(".js-leaflet-map-category-".concat(this.leafletMapId))
                            .forEach(function (categoryElement) { return enabledCategories_1.push(categoryElement.textContent); });
                        return [4 /*yield*/, this.fetchPois(enabledCategories_1)];
                    case 1:
                        pois = _d.sent();
                        overlayMaps = {};
                        markersByCategory = new Map();
                        for (_i = 0, pois_1 = pois; _i < pois_1.length; _i++) {
                            poi = pois_1[_i];
                            if (!poi.categories) {
                                continue;
                            }
                            for (_b = 0, _c = poi.categories; _b < _c.length; _b++) {
                                category = _c[_b];
                                categoryId = category['@id'];
                                if (!enabledCategories_1.includes(categoryId)) {
                                    continue;
                                }
                                if (!markersByCategory.has(categoryId)) {
                                    markers_1 = this.createMarkerLayer(category);
                                    categoryLayerGroup = L.layerGroup();
                                    categoryLayerGroup.addLayer(markers_1);
                                    categoryLayerGroup.addTo(this.map);
                                    overlayMaps[category.displayName] = categoryLayerGroup;
                                    markersByCategory.set(categoryId, markers_1);
                                }
                                markers = markersByCategory.get(category['@id']);
                                iconUrl = 'leaflet/default';
                                if (category.icon !== undefined && category.icon !== null) {
                                    iconUrl = "/.imaging/default/dam".concat(category.icon, "/jcr:content.jpg");
                                }
                                borderColour = (_a = poi.secondaryCategory) === null || _a === void 0 ? void 0 : _a.colour;
                                icon = this.createMarkerIcon(this.imageServiceBaseUrl + iconUrl, borderColour);
                                marker = L.marker([poi.latitude, poi.longitude], { icon: icon });
                                overlayText = "\n\t\t\t\t\t\t<h3>".concat(poi.title, "</h3>\n\t\t\t\t\t\t").concat((poi.overlayImage !== undefined && poi.overlayImage !== null && poi.overlayImage["@path"] !== undefined && poi.overlayImage["@path"] !== null)
                                    ? "<div><img src=\"".concat(this.imageServiceBaseUrl, "/.imaging/default/dam").concat(poi.overlayImage["@path"], "/jcr:content.jpg?width=150\" />").concat(poi.overlayImage.metadata !== undefined && poi.overlayImage.metadata !== null && poi.overlayImage.metadata.rights !== undefined && poi.overlayImage.metadata.rights !== null ? "<p class=\"leaflet-overlay-image-rights\">".concat(poi.overlayImage.metadata.rights, "</p>") : "", "</div>")
                                    : "", "\n\t\t\t\t\t\t").concat((poi.overlayText !== undefined && poi.overlayText !== null) ? poi.overlayText : "", "\n\t\t\t\t\t\t").concat((poi.overlayLink !== undefined && poi.overlayLink !== null && poi.overlayLink !== "none") ? "<a class=\"md-button md-button-leaflet\" href=\"".concat(poi['overlayLink' + poi.overlayLink], "\" target=\"_blank\"><span class=\"ic-arrow4-right\" aria-hidden=\"true\"></span> zur Detailseite</a>") : "", "\n\t\t\t\t\t");
                                overlay = L.responsivePopup().setContent(overlayText);
                                marker.bindPopup(overlay);
                                markers.addLayer(marker);
                            }
                        }
                        layerControl = L.control.layers(null, overlayMaps, { collapsed: false });
                        layerControl.addTo(this.map);
                        this.initializeLegend(pois);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _d.sent();
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LeafletMap.prototype.fetchPois = function (categories) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(encodeURI("/.rest/leaflet-map?categories=".concat(categories.join('|'))))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.results];
                }
            });
        });
    };
    LeafletMap.prototype.createMarkerLayer = function (category) {
        var layer = L.layerGroup();
        if ((category === null || category === void 0 ? void 0 : category.clusteringDisabled) == 'true') {
            return layer;
        }
        if ((category === null || category === void 0 ? void 0 : category.clusterColorForeground) && (category === null || category === void 0 ? void 0 : category.clusterColorBackground)) {
            layer = L.markerClusterGroup({
                iconCreateFunction: function (cluster) {
                    return L.divIcon({
                        className: '',
                        html: "\n\t\t\t\t\t\t\t<div class=\"marker-cluster\" style=\"position: absolute; top: 50%; left: 50%; width: 40px; height: 40px; background-color: ".concat(category.clusterColorBackground, "; transform: translate(-50%, -50%);\">\n\t\t\t\t\t\t\t\t<div style=\"background-color: ").concat(category.clusterColorForeground, "\">\n\t\t\t\t\t\t\t\t\t<span>").concat(cluster.getChildCount(), "</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t"),
                    });
                },
            });
        }
        else {
            layer = L.markerClusterGroup();
        }
        return layer;
    };
    LeafletMap.prototype.createMarkerIcon = function (iconUrl, borderColour) {
        return L.divIcon({
            html: "\n\t\t\t\t<span class=\"leaflet-marker-icon-container\">\n\t\t\t\t\t<img class=\"leaflet-marker-icon-rounded\" alt=\"Marker\" src=\"".concat(iconUrl, "\"  ").concat(borderColour !== undefined && borderColour !== null && borderColour !== "" ? "style=\"border: 2px solid ".concat(borderColour, ";\"") : "", " />\n\t\t\t\t</span>\n\t\t\t"),
            className: "",
            iconSize: [32, 32],
        });
    };
    LeafletMap.prototype.initializeLegend = function (pois) {
        var legend = L.control({ position: "bottomleft" });
        legend.onAdd = function () {
            var added = new Set();
            var rootDiv = L.DomUtil.create("div", "leaflet-legend");
            for (var _i = 0, pois_2 = pois; _i < pois_2.length; _i++) {
                var poi = pois_2[_i];
                var secondaryCategory = poi.secondaryCategory;
                if (!secondaryCategory || added.has(secondaryCategory['@id'])) {
                    continue;
                }
                added.add(secondaryCategory['@id']);
                rootDiv.innerHTML += "\n\t\t\t\t\t<span>\n\t\t\t\t\t\t<span class=\"leaflet-legend-category\" style=\"border: solid 2px ".concat(secondaryCategory.colour, "\"></span>\n\t\t\t\t\t\t").concat(secondaryCategory.displayName, "\n\t\t\t\t\t</span>\n\t\t\t\t\t<br />");
            }
            return rootDiv;
        };
        legend.addTo(this.map);
    };
    return LeafletMap;
}(Leaflet_1.Leaflet));
exports.LeafletMap = LeafletMap;
function addLeafletMapStyle() {
    if (document.querySelector("#js-leaflet-map-style")) {
        console.log("The style already exists.");
        return;
    }
    var style = document.createElement("style");
    style.id = "js-leaflet-map-style";
    style.innerHTML = "\n\t\tdiv.leaflet-map-container {\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\n\t\t\twidth: 100%;\n\t\t\theight: 400px;\n\t\t}\n\n\t\tdiv.leaflet-legend {\n\t\t\tpadding: 6px;\n\t\t\tbackground: rgba(255, 255, 255, 0.8);\n\t\t\tline-height: 18px;\n\t\t}\n\n\t\tspan.leaflet-legend-category {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 9px;\n\t\t\theight: 9px;\n\t\t\tborder-radius: 50%;\n\t\t\tmargin-right: 2px;\n\t\t}\n\n\t\tdiv.leaflet-popup-content {\n\t\t\tmargin: 0;\n\t\t\tpadding: 13px 24px 13px 20px;\n\t\t\twidth: 270px;\n\t\t}\n\n\t\t.leaflet-container a.md-button-leaflet {\n\t\t\tcolor: #FFFFFF;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.leaflet-container a.md-button-leaflet:hover {\n\t\t\tcolor: #E2002A;\n\t\t}\n\n\t\tdiv.leaflet-popup-content h3 {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\tdiv.leaflet-popup-content p {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\tdiv.leaflet-popup-content ul {\n\t\t\tmargin-top: 4px;\n\t\t\tmargin-bottom: 4px;\n\t\t}\n\n\t\tdiv.leaflet-popup-content ul li {\n\t\t\tmargin-top: 0;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\tdiv.leaflet-popup-content .leaflet-overlay-image-rights {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\n\t\t\tcolor: #878787;\n\t\t\tfont-size: 0.75em;\n\t\t\tfont-style: italic;\n\t\t}\n\n\t\tspan.leaflet-marker-icon-container {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 32px;\n\t\t\theight: 32px;\n\t\t}\n\n\t\tspan.leaflet-marker-icon-container img.leaflet-marker-icon-rounded {\n\t\t\twidth: 32px;\n\t\t\theight: 32px;\n\t\t\tborder-radius: 50%;\n\t\t}\n\t";
    document.head.appendChild(style);
}
